<template>
  <nav v-if="totalPages > 1" aria-label="Table pagination">
    <ul class="pagination">
      <li class="page-item" :class="{ active: currentPage === 1 }">
        <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
      </li>
      <li class="page-item" v-if="showChevronLeft">
        <div
          class="page-link page-icon"
          @click.prevent="changePage(currentPage - 1)"
          @keydown.left="changePage(currentPage - 1)"
        >
          <dx-icon icon="circle-chevron-left" />
        </div>
      </li>
      <li
        class="page-item"
        :class="{ active: page === currentPage }"
        v-for="page in displayedPages"
        :key="page"
      >
        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
      </li>
      <li class="page-item" v-if="showChevronRight">
        <div
          class="page-link page-icon"
          @click.prevent="changePage(currentPage + 1)"
          @keydown.left="changePage(currentPage + 1)"
        >
          <dx-icon icon="circle-chevron-right" />
        </div>
      </li>
      <li class="page-item" :class="{ active: currentPage === totalPages }">
        <a class="page-link" href="#" @click.prevent="changePage(totalPages)">{{ totalPages }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleChevronRight, faCircleChevronLeft } from '@fortawesome/free-solid-svg-icons';

library.add(faCircleChevronRight, faCircleChevronLeft);

export default {
  name: 'dx-pagination',
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    page: Number,
  },
  data() {
    return {
      currentPage: this.page || 1,
    };
  },
  computed: {
    displayedPages() {
      const totalDisplayPages = 3;
      const middlePage = Math.ceil(totalDisplayPages / 2);
      let startPage = this.currentPage - middlePage + 1;
      if (startPage < 1) {
        startPage = 1;
      }
      let endPage = startPage + totalDisplayPages - 1;
      if (endPage > this.totalPages) {
        endPage = this.totalPages;
        startPage = endPage - totalDisplayPages + 1;
        if (startPage < 1) {
          startPage = 1;
        }
      }
      const pages = [];
      if (startPage > 1) {
        pages.push(startPage);
      }
      for (let i = startPage + 1; i < endPage; i += 1) {
        pages.push(i);
      }
      if (endPage < this.totalPages) {
        pages.push(endPage);
      }
      return pages;
    },
    showChevronRight() {
      return this.currentPage !== this.totalPages && this.totalPages > 2;
    },
    showChevronLeft() {
      return this.currentPage !== 1 && this.totalPages > 2;
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) {
        return;
      }
      this.currentPage = page;
      this.$emit('page-changed', page);
    },
  },
};
</script>

<style>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.page-item {
  display: inline-block;
  margin: 0 5px;
}

.page-link {
  display: block;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  text-decoration: none;
  color: #333;
}

.page-icon {
  border: none !important;
}

.page-link:hover {
  background-color: #f5f5f5;
}

.page-item.disabled .page-link {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-item.active .page-link {
  background-color: #007bff;
  color: #fff;
}
</style>
